var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 84,
    height: 40,
    viewBox: "0 0 84 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "logo"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 21",
    d: "M42 15.0909C42 14.4884 42.4884 14 43.0909 14C49.1158 14 54 18.8842 54 24.9091V40H44C42.8954 40 42 39.1046 42 38V15.0909Z",
    fill: "url(#paint0_linear_150_631)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 23",
    d: "M2 26L29.2195 26C35.7257 26 41 20.7257 41 14.2195L13 14.2195C14 13.0742 16.6 10.6854 19 10.2927C22 9.80184 6 8.82013 -3.43294e-07 18.1463L-8.74228e-08 24C-3.91405e-08 25.1046 0.895431 26 2 26Z",
    fill: "url(#paint1_linear_150_631)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 22",
    d: "M0.999378 40C0.447441 40 6.74578e-06 39.5526 6.39843e-06 39.0006C2.68713e-06 33.1033 5.09037 28.4934 10.9871 28.4135C15.145 28.3572 19.6722 28.0128 23 27C34.5 23.5 41 14 41 14L41 20C41 31.0457 32.0457 40 21 40L0.999378 40Z",
    fill: "url(#paint2_linear_150_631)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Subtract",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M64 0H54V10H62.5C67.7467 10 72 14.2533 72 19.5C72 24.7467 67.7467 29 62.5 29H54V40H64C75.0457 40 84 31.0457 84 20C84 8.95431 75.0457 0 64 0Z",
    fill: "url(#paint3_linear_150_631)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M63 0.00553846H19C19 0.00553846 8.05621 0.505385 3.5 7.50323C0.571006 12.0018 0 18 0 18C0 18 5.12529 13.1025 9 11.502C12.5957 10.0167 19 10.0025 19 10.0025H63C63 10.0025 69.6935 9.83137 73.5 11.0022C80 13.0016 84 18 84 18C84 18 83.929 12.5017 81 8.00308C75.4675 -0.494233 63 0.00553846 63 0.00553846Z",
    fill: "url(#paint4_linear_150_631)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_150_631",
    x1: 43,
    y1: 15,
    x2: 73.215,
    y2: 18.0337,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BD00FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3604C3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_150_631",
    x1: 11.5,
    y1: 29.9268,
    x2: -0.806897,
    y2: 9.46112,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EB00FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3604C3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_150_631",
    x1: 41,
    y1: 16.9944,
    x2: 52.3725,
    y2: 48.1946,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BD00FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3604C3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_150_631",
    x1: 71,
    y1: 8,
    x2: 96.2095,
    y2: 23.0699,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EA00FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6F04C3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_150_631",
    x1: 66.5,
    y1: 22.9929,
    x2: 78.9042,
    y2: -12.4059,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BD00FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3604C3"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.1a4e8ef636df55e0b9e50a6ad54b637d.svg";
export { ForwardRef as ReactComponent };